const reportWebVitals = onPerfEntry => {
  // Simplified version without web-vitals dependency
  if (onPerfEntry && onPerfEntry instanceof Function) {
    // Performance metrics can be added here if needed
    console.log('Performance monitoring disabled');
  }
};

export default reportWebVitals;
